"use client";
import './globals.css';
import RootLayout from './layout.server';
import { useState, useEffect } from 'react';
import { DarkModeProvider } from './darkModeContext';
import { useTranslation } from 'react-i18next';
import MainNavbar from './components/navbar';
import Footer from './components/footer';

export default function ClientLayout({ children }) {
  const { i18n } = useTranslation();

  const [isLanguageLoaded, setIsLanguageLoaded] = useState(false);

  useEffect(() => {
    // Retrieve the saved language from localStorage
    const savedLanguage = localStorage.getItem('language') || 'fr'; // default to French
    if (i18n.language !== savedLanguage) {
      // If the current i18n language is different from the saved one, change it
      i18n.changeLanguage(savedLanguage);
    }
    // Set the language as loaded once the change is applied
    setIsLanguageLoaded(true);
  }, [i18n]);
  // Prevent rendering until language is loaded to avoid flicker
  if (!isLanguageLoaded) return null;

  return (
    <RootLayout>
    <DarkModeProvider>
      <MainNavbar />
      <main data-bs-theme="dark" className="component relative w-full flex flex-col color-mode items-end dark:bg-dark">
        {children}
      </main>
      <Footer />
    </DarkModeProvider>
    </RootLayout>
  );
}
